<div class="header _sticky _top-0 _bg-primary-1-tint-10 _w-full _z-10">
    <div class="_w-full _bg-primary-1-tint-10 _h-nudge-2">
      <div #progressBar class="_bg-primary-1 _h-nudge-2 _w-0"></div>
    </div>
 </div>
 <div #scrollContainer
    class="_overflow-scroll _no-scrollbar"
    [ngStyle]="{ height: heightOffset ? 'calc(100% - ' + (heightOffset - 2) + 'px)' : '100%' }"
    (scroll)="onScroll($event)">
    <div (cdkObserveContent)="onContentChange()" class="_h-full">
        <ng-content></ng-content>
    </div>
    <div *ngIf="useOverflowGradient && overflows && scrolledPercentage !== 100" 
        class="_mask-gradient-bottom-top _h-10 _w-full _top-auto _bottom-0">
    </div>
 </div>
